import React from 'react';

export default class Rollover extends React.Component {
    render() {
        let className = 'cc-rollover';
        const directionInfo = this.props.directionInfo;
        const arrowClassName = `cc-rollover-arrow cc-rollover-${directionInfo.direction}`;
        const boxClassName = `cc-rollover-box cc-rollover-${directionInfo.direction}`;
        if (directionInfo.slideUp) {
            className += ' cc-rollover-slideup';
        } else if (directionInfo.slideLeft) {
            className += ' cc-rollover-slideleft';
        }
        return (
            <div className={className} onMouseEnter={this.props.onMouseEnter} onMouseLeave={this.props.onMouseLeave}>
                <div className={arrowClassName} />
                <div className={boxClassName}>{this.props.children}</div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Rollover.jsx